import { isDifferential } from "@corca/core";

import type { NodeModel } from "@/models/nodes/types";

export function getNegativeCondition(condition: string) {
  if (condition.startsWith("not:")) return condition.substring(4);
  if (condition.startsWith("!")) return condition.substring(1);
  return null;
}

function getNodeTypeSegment(node: NodeModel): string {
  if (node.type === "operator") return `operator:${node.operatorType}`;
  if (isDifferential(node)) return "function:differential";
  return node.type;
}

export function buildFullPathFromAncestors(node: NodeModel) {
  const path = [];
  let currentNode: NodeModel | null = node;

  while (currentNode) {
    path.unshift(getNodeTypeSegment(currentNode));
    if (currentNode.parent) {
      path.unshift(currentNode.parent.childrenPlease.indexOf(currentNode).toString());
    }
    currentNode = currentNode.parent ?? null;
  }

  return path.join("/");
}

export function buildPathsToDescendants(node: NodeModel): string[] {
  const paths: string[] = [];
  const rootSegment = getNodeTypeSegment(node);

  function traverse(current: NodeModel, prefix: string) {
    current.nodes.forEach((child, index) => {
      const childPath = `${prefix}/${index}/${getNodeTypeSegment(child)}`;
      paths.push(childPath);
      traverse(child, childPath);
    });
  }

  traverse(node, rootSegment);
  return paths;
}
